<template>
  <custom-select
    v-model="getEjercicio"
    :items="ejercicios"
    :label="label"
    hide-details>
  </custom-select>
</template>

<script>
import CustomSelect from './sinColumnas/Select.vue';

const hoy = new Date();

export default {
  name: 'EjercicioPicker',
  props: {
    value: {
      type: [Number, String],
      required: false,
      default() {
        return hoy.getFullYear();
      },
    },
    label: {
      type: String,
      required: false,
      default: 'Ejercicio',
    },
    sinPeriodo: {
      type: Boolean,
      requirded: false,
      default: false,
    },
  },
  components: {
    CustomSelect,
  },
  data() {
    return {
      hoy: new Date(),
    };
  },
  computed: {
    getRangejercicios() {
      const esteEjercicio = this.hoy.getFullYear();
      return this.$range((esteEjercicio - 4), (esteEjercicio + 2)).reverse();
    },
    ejercicios() {
      return this.getRangejercicios;
    },
    getEjercicio: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>

<style lang="scss">

</style>
